import React, { Component } from "react";
import Render from "../../../components/Renderer";
import { Divider, message } from "antd";
import validatejs from "validate.js";
import { Constraints } from "./Constraints";
import {
  insertParkingSlot,
  updateParkingSlot
} from "../../../redux/actions/setting";
import { connect } from "react-redux";
import { getParkingBay, getAirport } from "../../../redux/actions/dropdown";

class ParkingSlotEdit extends Component {
  state = {
    form: {},
    fileList: [],
    data: [{ key: 1 }],
    disabledSave: false,
    filterAirport: []
  };

  componentDidMount() {
    const { selected, params } = this.props;
    let { form } = this.state;
    form = { ...selected, ...form, ...params };
    this.setState({ form, errors: validatejs(form, Constraints) });
    this.setFilterAirport();
  }

  setFilterAirport = () => {
    this.props.getAirport().then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        this.setState({
          filterAirport: data
        });
      }
    });
  };

  onChange = ({ name, value, error }) => {
    let { form, errors } = this.state;
    form[name] = value;
    if (errors === undefined) errors = {};
    if (error === undefined) delete errors[name];
    else errors[name] = error.join();
    if (Object.keys(errors).length === 0) errors = undefined;
    this.setState({ form, errors });
  };

  renderInput = (name, text, index) => {
    var template = {
      type: "input",
      name: name,
      value: text,
      placeholder: ""
    };
    return Render(template, ({ name, value }) =>
      this.onChangeTable(index, name, value)
    );
  };

  onSave = () => {
    this.setState({ disabledSave: true }, () => {
      const { form } = this.state;
      const { selected } = this.props;
      if (selected) {
        // update
        const body = {
          parkingSlotId: form.parkingSlotId,
          airportId: form.airportId,
          parkingSlotNameTH: form.parkingSlotNameTH,
          parkingSlotNameEN: form.parkingSlotNameEN,
          remark: form.remark,
          isEnable: form.display ? 1 : 0,
          aircraftWidth: form.aircraftWidth,
          aircraftLength: form.aircraftLength,
          flightScope: form.flightScope,
        };
        this.props.updateParkingSlot(body).then(res => {
          setTimeout(() => {
            this.setState({ disabledSave: false });
          }, 500);
          if (res.status === 400) {
            message.error("ไม่สามารถเพิ่มหรือแก้ไขข้อมูลได้");
          } else if (
            res &&
            res.payload.status === 200 &&
            res.type.endsWith("SUCCESS")
          ) {
            message.success("Update Parking Slot success");
            this.props.onRefresh(this.props.name);
            this.props.getParkingBay();
          }
        });
      } else {
        const body = {
          airportId: form.airportId,
          listParkingSlot: [
            {
              parkingSlotNameTH: form.parkingSlotNameTH,
              parkingSlotNameEN: form.parkingSlotNameEN,
              remark: form.remark,
              isEnable: form.display ? 1 : 0,
              aircraftWidth: form.aircraftWidth,
              aircraftLength: form.aircraftLength,
              flightScope: form.flightScope,
            }
          ]
        };
        this.props.insertParkingSlot(body).then(res => {
          setTimeout(() => {
            this.setState({ disabledSave: false });
          }, 500);
          if (res.status === 400) {
            message.error("ไม่สามารถเพิ่มข้อมูลได้");
          } else if (
            res &&
            res.payload.status === 201 &&
            res.type.endsWith("SUCCESS")
          ) {
            message.success("Insert Parking Slot success");
            this.props.onRefresh(this.props.name);
            this.props.getParkingBay();
          }
        });
      }
    });
  };

  render() {
    const { form, errors, disabledSave, filterAirport } = this.state;
    const template = [
      {
        type: "select",
        name: "airportId",
        label: "Airports",
        value: form.airportId,
        disabled: true,
        constraint: Constraints,
        placeholder: "Select...",
        options: {
          name: "airPortOptions",
          id: "airportID",
          text: "airportName",
          dataLoad: 1,
          dataService: filterAirport
        }
      },
      {
        type: "input",
        name: "parkingSlotNameEN",
        label: "Parking Slot",
        constraint: Constraints,
        value: form.parkingSlotNameEN,
        addonAfter: "EN",
        placeholder: ""
      },
      {
        type: "input",
        name: "parkingSlotNameTH",
        constraint: Constraints,
        value: form.parkingSlotNameTH,
        addonAfter: "TH",
        placeholder: ""
      },
      {
        type: "select",
        name: "flightScope",
        label: "Flight Scope",
        constraint: Constraints,
        value: form.flightScope,
        options: {
          name: 'flightScope',
          id: 'id',
          text: 'label',
          dataLoad: 1,
          dataService: [
            { id: 'domestic', label: 'Domestic' },
            { id: 'inter', label: 'Inter' },
            { id: 'both', label: 'Both' },
          ]
        }
      },
      {
        type: "input",
        name: "aircraftWidth",
        number: true,
        label: "Aircraft limit",
        placeholder: "width",
        addonAfter: "meter",
        constraint: Constraints,
        value: form.aircraftWidth
      },
      {
        type: "input",
        number: true,
        name: "aircraftLength",
        label: "",
        addonAfter: "meter",
        placeholder: "length",
        constraint: Constraints,
        value: form.aircraftLength
      },
      {
        type: "textarea",
        name: "remark",
        label: "Remark",
        placeholder: "remark",
        constraint: Constraints,
        value: form.remark
      },
      {
        type: "switch",
        name: "display",
        label: "Display (On/Off)",
        value: form.display
      }
    ];
    return (
      <div className="card card-body card-body-component">
        {template.map((data, i) => {
          return (
            <div key={i} className="form-row form-inline mb-2 col-12 px-0">
              <label className="col-lg-2 col-md-3 col-sm-4 col-5 justify-content-end">
                {data.label && data.label + " : "}
              </label>
              <div className="col-lg-4 col-md-6 col-sm-8 col-12">
                {Render(data, this.onChange)}
              </div>
            </div>
          );
        })}
        <Divider />
        {/* footer */}
        <div className="text-center mt-2">
          <button
            onClick={() => this.props.onClose(this.props.name)}
            className="btn btn-light mr-2"
          >
            Cancel
          </button>
          <button
            disabled={errors !== undefined || disabledSave}
            onClick={this.onSave}
            className="btn btn-success mr-2"
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = dispatch => ({
  insertParkingSlot: body => dispatch(insertParkingSlot(body)),
  updateParkingSlot: body => dispatch(updateParkingSlot(body)),
  getParkingBay: () => dispatch(getParkingBay()),
  getAirport: () => dispatch(getAirport())
});

export default connect(mapStateToProps, mapDispatchToProps)(ParkingSlotEdit);
